<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <MaintanceReasonList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import MaintanceReasonList from '@/components/settings/test-registers/maintanceReason/MaintanceReasonList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'MaintanceReason',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      MaintanceReasonList
    },
    methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addmaintancereason' })
    }
  }
  }
</script>
